import { contactWrite, type ContactEmail, type ContactPhone } from '@/app/(main)/client-detail/utils/contacts';
import type { CreateClientFormData } from '@/types/clientsApiTypes';
import { formatMMDDYYYYToYYYYMMDD } from '@/utils/formatDate';
import type { PayloadWithIsImageDeleted } from '../../../sections/types';

type BasicInfoFields = Pick<
  CreateClientFormData['primary_passenger']['client'],
  | 'client_id'
  | 'userHasCertifiedTheInformation'
  | 'preferred_name'
  | 'profile_picture_url'
  | 'first_name'
  | 'middle_name'
  | 'last_name'
  | 'gender'
  | 'email'
  | 'additional_emails'
  | 'date_of_birth'
  | 'phone'
  | 'phones'
  | 'preferred_airport_ids'
  | 'profile_picture_gallery_id'
> & {
  is_image_deleted: boolean;
  crm_emails?: ContactEmail[] | null;
  crm_phones?: ContactPhone[] | null;
};

export const getBasicInfoPayload = (
  values: BasicInfoFields
): PayloadWithIsImageDeleted['client'] => {
  return {
    id: values.client_id,
    is_image_deleted: values.is_image_deleted,
    userHasCertifiedTheInformation: values.userHasCertifiedTheInformation,
    preferred_name: values.preferred_name,
    profile_picture_gallery_id: values.profile_picture_gallery_id,
    first_name: values.first_name,
    middle_name: values.middle_name,
    last_name: values.last_name,
    gender: values.gender,
    date_of_birth: formatMMDDYYYYToYYYYMMDD(values.date_of_birth),
    preferred_airport_ids: values.preferred_airport_ids,
    ...contactWrite(values, values.crm_emails, values.crm_phones),
  };
};